import { searchTerms } from '../../../../constants';
import { getCurrentSearchLast6Months, getAllMlsLast12Months } from '../agGrid/agGrid';

const dateWithRankTiebreaker = (valueA, valueB, nodeA, nodeB) => {
    const dateA = new Date(valueA).getTime();
    const dateB = new Date(valueB).getTime();

    if (dateA !== dateB) {
        return dateA - dateB;
    }

    return nodeB.data.rank - nodeA.data.rank;
};

const activityView = ({
                        agentsColumns,
                        cellRenderers,
                        colSettings,
                        tableViewNames,
                        TextFloatingFilterComponent
                    }) => {
    return{
        id: tableViewNames.activity,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 100,
            sizePerPageList: [10, 20, 50, 100]
        },
        defaultSort: {
            colId: agentsColumns.date.id,
            sortDir: 'desc'
        },
        tables: [
            {
                headerGroupTitle: getCurrentSearchLast6Months,
                children: [
                    { col: agentsColumns.rank, colDef: colSettings.textXsRightAlign },
                    {
                        col: agentsColumns.agentName,
                        colDef: colSettings.textLg,
                        cellRenderer: cellRenderers.agentNameLink,
                        filterOptions: {
                            filter: 'agTextColumnFilter',
                            floatingFilterComponent: TextFloatingFilterComponent,
                            floatingFilterComponentParams: {
                                placeholder: searchTerms.searchName
                            }
                        }
                    },
                    {
                        col: agentsColumns.officeName,
                        colDef: colSettings.textLg,
                        filterOptions: {
                            filter: 'agTextColumnFilter',
                            floatingFilterComponent: TextFloatingFilterComponent,
                            floatingFilterComponentParams: {
                                placeholder: searchTerms.searchOffice,
                            }
                        }
                    },
                    {
                        col: agentsColumns.activity,
                        colDef: colSettings.textXl,
                        filterOptions: {
                            filter: 'agTextColumnFilter',
                            floatingFilterComponent: TextFloatingFilterComponent,
                            floatingFilterComponentParams: {
                                placeholder: searchTerms.searchActivity,
                            }
                        }
                    },
                    {
                        col: agentsColumns.side,
                        colDef: colSettings.textSm,
                    },
                    {
                        col: agentsColumns.date,
                        colDef: {
                            ...colSettings.textSm,
                            comparator: dateWithRankTiebreaker
                        }
                    }
                ]
            },
            {
                headerGroupTitle: getAllMlsLast12Months,
                children: [
                    { col: agentsColumns.listVolume, colDef: colSettings.numberMdInteger},
                    { col: agentsColumns.sellVolume, colDef: colSettings.numberMdInteger },
                    { col: agentsColumns.totalVolume, colDef: colSettings.numberMdInteger }
                ]
            }
        ]
    }
};

export default activityView;
